// VELARO Theme v2.0 — Complete JS

document.addEventListener('DOMContentLoaded', function() {

  // ── NAV SCROLL ──
  var header = document.getElementById('siteHeader');
  window.addEventListener('scroll', function() {
    if (header) header.classList.toggle('stk', window.scrollY > 60);
  });

  // ── HAMBURGER MENU ──
  var hamburger = document.getElementById('hamburger');
  var mobileNav = document.getElementById('mobileNav');
  var mobileOverlay = document.getElementById('mobileOverlay');

  function openMenu() {
    if (mobileNav) mobileNav.classList.add('open');
    if (mobileOverlay) mobileOverlay.classList.add('open');
    if (hamburger) hamburger.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (mobileNav) mobileNav.classList.remove('open');
    if (mobileOverlay) mobileOverlay.classList.remove('open');
    if (hamburger) hamburger.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (hamburger) hamburger.addEventListener('click', function() {
    this.classList.contains('open') ? closeMenu() : openMenu();
  });
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMenu);
  document.querySelectorAll('.mobile-nav a').forEach(function(a) {
    a.addEventListener('click', closeMenu);
  });

  // ── MARQUEE ──
  var MNL = ['15 Bar Druk','Nespresso Compatibel','Oplaadbaar','Draagbaar','30 Dagen Retour','Gratis EU Verzending','3-in-1','Barista Kwaliteit','Outdoor Proof','USB-C'];
  var MEN = ['15 Bar Pressure','Nespresso Compatible','Rechargeable','Portable','30 Day Returns','Free EU Shipping','3-in-1','Barista Quality','Outdoor Proof','USB-C'];
  function buildMarquee() {
    var track = document.getElementById('mtrack');
    if (!track) return;
    var isNL = document.documentElement.lang === 'nl' || document.querySelector('html').lang === 'nl';
    var items = isNL ? MNL : MEN;
    track.innerHTML = '';
    var doubled = items.concat(items).concat(items).concat(items);
    doubled.forEach(function(s) {
      var el = document.createElement('span');
      el.className = 'mi';
      el.innerHTML = s + '<span class="md"></span>';
      track.appendChild(el);
    });
  }
  buildMarquee();

  // ── SMOOTH SCROLL ──
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var el = document.getElementById(id);
      if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  // ── SCROLL REVEAL ──
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) entry.target.classList.add('vs');
    });
  }, { threshold: 0.07 });
  document.querySelectorAll('.rv').forEach(function(el) { observer.observe(el); });

  // ── AJAX ADD TO CART (homepage product section) ──
  var cartBtn = document.getElementById('velaroAddToCart');
  if (cartBtn) {
    cartBtn.addEventListener('click', async function() {
      var colorKey = window.VELARO_ACTIVE_COLOR || 'champ';
      var colors = window.VELARO_COLORS || {};
      var colorData = colors[colorKey];
      var variantId = colorData ? colorData.id : null;

      if (!variantId) {
        window.location.href = colorData ? colorData.url : '/collections/all';
        return;
      }

      var txt = document.getElementById('velaroCartTxt');
      cartBtn.disabled = true;
      if (txt) txt.textContent = '...';

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        });

        if (res.ok) {
          var cartRes = await fetch('/cart.js');
          var cartData = await cartRes.json();
          document.querySelectorAll('.cart-count').forEach(function(el) {
            el.textContent = cartData.item_count;
          });
          var msg = document.getElementById('velaroCartMsg');
          if (msg) msg.style.display = 'block';
          if (txt) txt.textContent = '✓';
          setTimeout(function() {
            if (txt) txt.textContent = cartBtn.getAttribute('data-orig') || 'Add to cart';
            cartBtn.disabled = false;
          }, 2500);
        } else {
          window.location.href = colorData ? colorData.url : '/collections/all';
        }
      } catch(e) {
        window.location.href = colorData ? colorData.url : '/collections/all';
      }
    });
    var txt = document.getElementById('velaroCartTxt');
    if (txt) cartBtn.setAttribute('data-orig', txt.textContent.trim());
  }

  // ── AJAX ADD TO CART (add-on cards) ──
  document.querySelectorAll('.addon-cart-btn').forEach(function(btn) {
    btn.addEventListener('click', async function() {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) { window.location.href = btn.getAttribute('data-url') || '/collections/all'; return; }
      var origText = btn.textContent;
      btn.disabled = true;
      btn.textContent = '...';
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        });
        if (res.ok) {
          var cartRes = await fetch('/cart.js');
          var cartData = await cartRes.json();
          document.querySelectorAll('.cart-count').forEach(function(el) { el.textContent = cartData.item_count; });
          btn.textContent = '✓';
          setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 2000);
        } else { window.location.href = btn.getAttribute('data-url') || '/collections/all'; }
      } catch(e) { window.location.href = btn.getAttribute('data-url') || '/collections/all'; }
    });
  });

});

// ── COLOR PICKER (product section) ── global so Liquid onclick works
window.VELARO_ACTIVE_COLOR = 'champ';
function velaroPickColor(el) {
  document.querySelectorAll('.sws .sw').forEach(function(s) { s.classList.remove('on'); });
  el.classList.add('on');
  var colorKey = el.getAttribute('data-color');
  window.VELARO_ACTIVE_COLOR = colorKey;
  var nameEl = document.getElementById('colorName');
  if (nameEl) nameEl.textContent = el.getAttribute('data-label');
  var img = document.getElementById('prodImg');
  var src = el.getAttribute('data-img');
  if (img && src) {
    img.style.transition = 'opacity .28s';
    img.style.opacity = '0';
    setTimeout(function() { img.src = src; img.style.opacity = '1'; }, 280);
  }
  var msg = document.getElementById('velaroCartMsg');
  if (msg) msg.style.display = 'none';
}
